import type { NearMiss } from '@/types/intake';

/**
 * Loud interstitial for the 39016812-vs-39016012 keying-error class: the scanned barcode is one
 * edit away from a DIFFERENT in-flight kit. The tech must explicitly acknowledge before CONFIRM.
 */
export function NearMissDialog({
  nearMiss,
  onAcknowledge,
  onCancel,
}: {
  nearMiss: NearMiss;
  onAcknowledge: () => void;
  onCancel: () => void;
}) {
  return (
    <div className="modal-scrim" role="dialog" aria-modal="true" aria-labelledby="near-miss-title">
      <div className="modal tier-2" style={{ padding: '22px 22px 20px' }}>
        <div className="section-eyebrow" style={{ color: 'var(--amber)' }}>
          Possible keying error
        </div>
        <div id="near-miss-title" className="mb-2 text-lg font-semibold" style={{ color: 'var(--amber)' }}>
          Check the kit
        </div>
        <p className="mb-5 text-sm" style={{ color: 'var(--ink-700)', lineHeight: 1.55 }}>
          This barcode is one digit away from another kit in flight:{' '}
          <span className="font-mono font-semibold" style={{ color: 'var(--ink-950)' }}>
            {nearMiss.otherKitBarcode}
          </span>
          {nearMiss.otherMemberName ? ` (${nearMiss.otherMemberName})` : ''}. Make sure you have the right kit in hand.
        </p>
        <div className="flex gap-2">
          <button type="button" onClick={onCancel} className="btn-bench btn-bench-ghost flex-1">
            Re-scan
          </button>
          <button
            type="button"
            onClick={onAcknowledge}
            className="btn-bench flex-1"
            style={{ background: 'var(--amber)', borderColor: 'var(--amber)' }}
          >
            This is the right kit
          </button>
        </div>
      </div>
    </div>
  );
}
